import TratamientosEspecialesLayout from '@/views/tratamientos-especiales-bot/Layout.vue'
import TratamientosEspecialesDashboard from '@/views/tratamientos-especiales-bot/Dashboard.vue'

export default [
    {
        path: '/tratamientos-especiales-bot',
        component: TratamientosEspecialesLayout,
        meta: {
            requiresAuth: true,
            permiso: 'tebot',
            title: 'Tratamientos Especiales | Suizo Argentina',
            description: 'Sistema de Tratamientos Especiales - Suizo Argentina'
        },
        children: [
            {
                path: 'dashboard',
                name: 'te-dashboard',
                component: TratamientosEspecialesDashboard,
                meta: {
                    requiresAuth: true,
                    permiso: 'tebot',
                    title: 'Dashboard Tratamientos Especiales | Suizo Argentina',
                    description: 'Dashboard principal del sistema de Tratamientos Especiales'
                }
            },
            {
                path: 'registros',
                name: 'te-registros',
                component: () => import('@/views/tratamientos-especiales-bot/Registros.vue'),
                meta: {
                    requiresAuth: true,
                    permiso: 'tebot',
                    title: 'Registros Tratamientos Especiales | Suizo Argentina',
                    description: 'Gestión de registros de tratamientos especiales'
                }
            },
            {
                path: 'normalizador',
                name: 'te-normalizador',
                component: () => import('@/views/tratamientos-especiales-bot/Normalizador.vue'),
                meta: {
                    requiresAuth: true,
                    permiso: 'tebot',
                    title: 'Normalizador Tratamientos Especiales | Suizo Argentina',
                    description: 'Normalizador de teléfonos de tratamientos especiales'
                }
            },
            {
                path: 'pruebas',
                name: 'te-pruebas',
                component: () => import('@/views/tratamientos-especiales-bot/Pruebas.vue'),
                meta: {
                    requiresAuth: true,
                    permiso: 'tebot',
                    title: 'Pruebas Tratamientos Especiales | Suizo Argentina',
                    description: 'Sistema de pruebas para tratamientos especiales'
                }
            },
            {
                path: '',
                redirect: 'dashboard'
            }
        ]
    }
] 